import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export default class Deletepopup extends Component {
    state = { visible: false };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    hideModal = () => {
        this.setState({
            visible: false,
        });
    };

    delete = () => {
        this.props.delData()
    }

    delCance = () => {
        console.log('取消');
    }

    confirm = () => {
        const { address } = this.props
        const ismany = this.props.delType === 'btn'
        Modal.confirm({
            title: '提示',
            icon: <ExclamationCircleOutlined />,
            content: ismany ? `确认删除选中的${address}?` : `确认删除该条${address}?`,
            okText: <a onClick={this.delete}>确认</a>,
            cancelText: <a onClick={this.delCance}>取消</a>,
        });
    }

    render() {
        return (
            <span>
                {
                    this.props.delType === 'btn' ? <Button type='primary' onClick={this.confirm}>删除</Button>
                        :
                        <a onClick={this.confirm}>删除</a>
                }
            </span>
        )
    }

};